module.exports = __webpack_public_path__ + "static/media/3_col_3.ed24c228.jpg";